import { CSSProperties, PropsWithChildren } from "react";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";
import { ReactComponent as Wave } from "UIPalette/PageModal/assets/wave.svg";

type WaveBackgroundProps = PropsWithChildren;

export default function WaveBackground({ children }: WaveBackgroundProps) {
  const { insetPadding } = useMobilePlatform();
  const topStyle: CSSProperties | undefined = insetPadding ? { top: `${insetPadding.top + 16}px` } : undefined;
  const bottomStyle: CSSProperties | undefined = insetPadding ? { bottom: `${insetPadding.bottom + 16}px` } : undefined;

  return (
    <div className="relative" data-testid="wave-background">
      <Wave
        data-testid="wave-top"
        style={topStyle}
        className="pointer-events-none fixed h-[400px] left-1/2 w-[800px] -translate-y-1/2 -translate-x-1/2 top-0 md:top-40 md:h-[300px] md:-rotate-45 md:left-0 md:-translate-x-[20%]"
      />
      {children}
      <Wave
        data-testid="wave-bottom"
        style={bottomStyle}
        className="pointer-events-none h-[400px] md:h-[300px] w-[800px] fixed bottom-28 translate-y-1/2 left-1/2 -translate-x-1/2 rotate-180 md:translate-y-1/2 md:left-auto md:right-0 md:translate-x-[20%] md:rotate-[140deg]"
      />
    </div>
  );
}
